var exports = {
  "kL": "xcc377c0b--d40898--container",
  "Pf": "xcc377c0b--d40898--label",
  "nE": "xcc377c0b--d40898--agreement-checkbox",
  "xz": "xcc377c0b--d40898--agreement-checkbox--mobile",
};

module.exports = exports;
